import React, {useEffect, useState} from "react";
import NextLink from "next/link";
import {useParentComponentContext} from "../../context/ParentComponentContext";
import {usePageContext} from "../../context/PageContext";
import CCOLinkText from "./CCOLinkText";
import CCOOpenInNewTabIcon from "./CCOOpenInNewTabIcon";
import {generateDownloadTargetFromUrl, getUrl, resolveLinkWithPlaceholder} from "../../utility/navigationUtil";

interface Props {
    externalMenuLink?: boolean,
    children?: JSX.Element,
    contentId?: string,
    customStyle?: any,
    icon?: JSX.Element,
    name?: string,
    noLinkIcon?: boolean,
    noWrap?: boolean,
    onClick?: any,
    openInTab?: boolean,
    target: any,
    type?: string,
    displayContents?: boolean
    dataCypress?: string
    className?: string
    tabIndex?: number
}

function CCOLink(props: Props) {
    const parentComponentContext = useParentComponentContext();
    const pageContext = usePageContext();
    const showLinkIcon = !props.noLinkIcon;
    const display = props.displayContents ? "contents" : props.noWrap ? "inline-block" : "flex"
    const linkTarget = isTargetInNewTab(props.target, props.openInTab ? props.openInTab : false) ? "_blank" : "_self";
    const id = props.target && props.target.id ? props.target.id : "noContent";
    const downloadTarget = generateDownloadTargetFromUrl(props.target);
    const [href, setHref] = useState<string>('');

    useEffect(() => {
        const internalLinkTarget = (props.target.type === 'SOSInternalLink'  || props.target.type === 'SOSTeaser') ? resolveLinkWithPlaceholder(props.target, typeof window !== 'undefined' ? [localStorage, sessionStorage]: null, parentComponentContext.cmId, pageContext.page?.id) : null;
        if (internalLinkTarget !== null) {
            setHref(internalLinkTarget);
        } else {
            setHref(downloadTarget ?? getUrl(props.target));
        }
    }, [props.target, downloadTarget]);
    if (props.children) {
        return <NextLink tabIndex={props.tabIndex} className={props.className} data-cypress={props.dataCypress || 'ccoLink'}
                         data-info={'ccoLink-'+ props.target.id}
                         data-cypress-additional={href}
                         style={{display: props.externalMenuLink ? 'block' : undefined}}
                         target={linkTarget} id={"link-" + id}
                         shallow={false}
                         href={href} prefetch={false}
                         onClick={props.onClick}>
            {(props.openInTab && showLinkIcon) && <CCOOpenInNewTabIcon/>}
            {props.children}
        </NextLink>
    } else {
        return <NextLink className={props.className} data-cypress={props.dataCypress || 'ccoLink'}
                         data-info={'ccoLink-'+ props.target.id}
                         data-cypress-additional={href}
                         style={{display: display}} target={linkTarget}
                         id={"link-" + id} shallow={false}
                         href={href} prefetch={false}
                         onClick={props.onClick}>
            <CCOLinkText type={props.type} icon={props.icon} displayContents={props.displayContents}>
                <React.Fragment>
                    {(props.openInTab && showLinkIcon && props.name) && <CCOOpenInNewTabIcon/>}
                    {props.name ? props.name : props.target.teaserTitle}
                </React.Fragment>
            </CCOLinkText>
        </NextLink>
    }
}

function isTargetInNewTab(target: any, openInNewTab: boolean) {
    if (!target) {
        return openInNewTab;
    }
    if (typeof target === 'string') {
        return openInNewTab;
    } else {
        if (target.type && (target.type === "CMExternalLink" || target.type === "SOSWimmelbild")) {
            return true;
        }
        if (target.type && target.type === "SOSTeaser") {
            if (target.teaserTarget?.type === "SOSWimmelbild" || target.teaserTarget?.type === "CMExternalLink") {
                return true;
            } else {
                return openInNewTab;
            }
        } else {
            return openInNewTab
        }
    }
}

export default CCOLink